<template>
    <div style="position: absolute; top: 0px; left: 0px;">
        <div class="row mx-0 mb-0 p-0 gx-0">
            <div class="col-12 p-0">
                <img src="../../static/abulafia-popup-inv-final.jpg.jpeg" alt="Flyer of the exposition" style="width: 100%;">
            </div>
        </div>
        <div class="row mx-0 mb-3 text-center fontHeebo p-3"
            style="background-color: rgb(118, 119, 122); color: white; display: flex; justify-content: center;">
            <div style="font-size: 16px;" class="py-2 col-12">
                ברוכים.ות הבאים.ות לתערוכה
            </div>
            <div style="font-size: 32px; font-weight: 600;" class="py-2 col-12">
                יוסי אבולעפיה
            </div>
            <div style="font-size: 16px;" class="py-2 col-12">
                מוזמנים ומוזמנות להאזין לשיחה באורך מלא עם יוסי על התערוכה ועל חייו. ניתן להאזין תוך כדי הביקור בתערוכה או לשמור ולהאזין בזמנכם.ן
            </div>
        </div>

        <div class="row mx-0 py-4 d-flex justify-content-center align-items-center">
            <div class="col-3 d-flex justify-content-center">
                <button class="skipBtn" @click="skip(-10)" aria-label="Reculer de 10 secondes">
                    <svg xmlns="http://www.w3.org/2000/svg" width="34px" height="34px" fill="currentColor"
                        class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z" />
                        <path
                            d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466" />
                    </svg>
                    <span class="skipLabel">10</span>
                </button>
            </div>

            <div class="col-6 d-flex justify-content-center">
                <button class="playPauseBtn" @click="togglePlay" aria-label="Lecture / Pause">
                    <svg v-if="!isPlaying" xmlns="http://www.w3.org/2000/svg" width="90px" height="90px"
                        fill="#63C4C3" class="bi bi-play-circle" viewBox="0 0 16 16" style="transform: rotate(180deg);">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path
                            d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="90px" height="90px" fill="#f1750a"
                        class="bi bi-pause-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path
                            d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0z" />
                    </svg>
                </button>
            </div>

            <div class="col-3 d-flex justify-content-center">
                <button class="skipBtn" @click="skip(10)" aria-label="Avancer de 10 secondes">
                    <svg xmlns="http://www.w3.org/2000/svg" width="34px" height="34px" fill="currentColor"
                        class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
                        <path
                            d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                    </svg>
                    <span class="skipLabel">10</span>
                </button>
            </div>
        </div>

        <div class="row mx-0 px-4 pb-4 d-flex align-items-center">
            <div class="col-2 text-center" style="font-size: 13px;">{{ formatTime(currentTime) }}</div>
            <div class="col-8">
                <input type="range" class="progressBar" min="0" :max="duration || 0" step="0.1"
                    :value="currentTime" @input="onSeek($event.target.value)" />
            </div>
            <div class="col-2 text-center" style="font-size: 13px;">{{ formatTime(duration) }}</div>
        </div>

        <div class="row mx-0 mb-3 text-center fontHeebo p-3"
            style="background-color: rgb(118, 119, 122); color: white; display: flex; justify-content: center;">
            <div style="font-size: 32px;font-weight: 600;" class="py-2">
                תודה שביקרתם.
            </div>
            <div style="font-size: 16px; " class="py-2">
                למידע על המוזיאון, על תערוכות ואירועים המתקיימים בו במהלך החודש מוזמנים לבקר באתר האינטרנט שלנו ולעקוב
                אחרינו בפייסבוק ובאינסטגרם
            </div>

            <a :href="museumSite" style="text-decoration: none; display: flex; justify-content: center; width: 100%;">
                <div class="siteButton mt-2">
                    www.eindormuseum.co.il
                </div>
            </a>

            <div class="row d-flex justify-content-center align-items-center mt-4 mx-0"
                style="color:#63C4C3; gap: 30px;">
                <a :href="instaPage" class="links" style="text-decoration: none; width: auto;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" fill="currentColor"
                        class="bi bi-instagram" viewBox="0 0 16 16">
                        <path
                            d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
                    </svg>
                </a>
                <a :href="facebookPage" class="links" style="text-decoration: none; width: auto;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" fill="currentColor"
                        class="bi bi-facebook" viewBox="0 0 16 16">
                        <path
                            d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
                    </svg>
                </a>
            </div>
            <div class="row d-flex justify-content-center mt-4 pt-3" style="border-top: 1px solid white;">
                <a :href="eifoany" style="text-decoration: none;">
                    <div class="col-12 linksToWebsite" style="font-family: 'segoeui';">
                        developped by Eifoany
                    </div>
                </a>
            </div>
        </div>

    </div>
</template>

<script>

export default {

    data() {
        return {
            eifoany: "https://eifoany.web.app/",
            facebookPage: "https://www.facebook.com/eindormuseum",
            instaPage: "https://www.instagram.com/eindormuseum?igsh=aWNwenJ3eWJqNG1p",
            museumSite: " www.eindormuseum.co.il",
            audioUrl: 'https://firebasestorage.googleapis.com/v0/b/visiteindormuseum.appspot.com/o/YossiAbulafia%2FYossiAbulafiaV4.mp3?alt=media&token=af6ac6b6-6427-4fe5-937e-cf1dfdf25fe4',
            audio: null,
            isPlaying: false,
            currentTime: 0,
            duration: 0,
        };
    },

    mounted() {
        this.audio = new Audio(this.audioUrl);
        this.audio.addEventListener('timeupdate', this.onTimeUpdate);
        this.audio.addEventListener('loadedmetadata', this.onLoadedMetadata);
        this.audio.addEventListener('ended', this.onEnded);
    },

    beforeUnmount() {
        if (this.audio) {
            this.audio.pause();
            this.audio.removeEventListener('timeupdate', this.onTimeUpdate);
            this.audio.removeEventListener('loadedmetadata', this.onLoadedMetadata);
            this.audio.removeEventListener('ended', this.onEnded);
        }
    },

    methods: {
        togglePlay() {
            if (this.isPlaying) {
                this.audio.pause();
            } else {
                this.audio.play();
            }
            this.isPlaying = !this.isPlaying;
        },
        skip(seconds) {
            const newTime = this.audio.currentTime + seconds;
            this.audio.currentTime = Math.min(Math.max(newTime, 0), this.duration || 0);
        },
        onSeek(value) {
            this.audio.currentTime = parseFloat(value);
            this.currentTime = this.audio.currentTime;
        },
        onTimeUpdate() {
            this.currentTime = this.audio.currentTime;
        },
        onLoadedMetadata() {
            this.duration = this.audio.duration;
        },
        onEnded() {
            this.isPlaying = false;
        },
        formatTime(seconds) {
            if (!seconds || isNaN(seconds)) return '0:00';
            const m = Math.floor(seconds / 60);
            const s = Math.floor(seconds % 60);
            return `${m}:${s.toString().padStart(2, '0')}`;
        },
    },

};
</script>

<style scoped>
.links {
    color: white !important;
    text-decoration: none !important
}

.linksToWebsite {
    color: white !important;
    text-decoration: none !important
}

.siteButton {
    background: #63C4C3;
    width: 300px;
    height: 40px;
    font-size: 20px;
    font-family: Heebo;
    border-radius: 3px;
    padding-top: 5px;
    color: white !important;
    text-decoration: none !important
}

.siteButton:active {
    text-decoration: none !important
}

.playPauseBtn {
    background: none;
    border: none;
    padding: 0;
    line-height: 0;
}

.skipBtn {
    background: none;
    border: none;
    color: #63C4C3;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
}

.skipLabel {
    position: absolute;
    font-size: 11px;
    font-weight: bold;
    color: #63C4C3;
}

.progressBar {
    width: 100%;
    accent-color: #63C4C3;
}

.fontHeebo {
    font-family: Heebo;
}

@font-face {
    font-family: Heebo;
    src: url(../../static/Heebo/Heebo-VariableFont_wght.ttf);
}

.fontPacifico {
    font-family: Pacifico;
}

@font-face {
    font-family: Pacifico;
    src: url(../../static/Pacifico/Pacifico-Regular.ttf);
}
</style>
